import React from 'react';
import TitleSummaryList from '../tripSummary/TitleSummary';
import Summary from './Summary';
import { formatCurrency } from '../../utils/currency.utils';
import InvoiceAirReceiptCard from './InvoiceAirReceiptCard';
import { View, StyleSheet } from 'react-native';
import BaseText from '../BaseText';
import { CommonStyles, Color } from '../../styles';
import { useComponentTKey, i18nNS } from '../../i18n';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../../store/selectors/auth.selector';
import { selectTravelCartPassengers } from '../../store/selectors/trip.selector';
import { AA_ENABLED, EVENTS_ENABLED, REBOOK_ENABLED } from '../../config/env';

const InvoiceAirSummaryList = ({ multiPnrResp, response, price, pnr }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('InvoiceAirSummaryList');
  const currency = useSelector(selectCompanyCurrency);
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);
  const lastIndex = response.AirLegs[0].AirSegments.length;
  const fromCity = response.AirLegs[0]?.AirSegments[0]?.DepartAirportCityName;
  const toCity = response.AirLegs[0]?.AirSegments[lastIndex - 1]?.ArrivalAirportCityName;
  const title = `${fromCity} ${t(tKey('to'))} ${toCity}`;
  const passengersData = useSelector(selectTravelCartPassengers);
  const passengerName = passengersData?.map((item) => {
    return { name: item.FirstName + ' ' + item.LastName, seat: item.SelectedSeatNumber };
  });
  const isMultiPnr = multiPnrResp?.length > 1 ? true : false;
  return (
    <>
      <TitleSummaryList
        desc={title}
        amount={
          AA_ENABLED && response?.IsRedeem
            ? response.TotalPoints
            : isMultiPnr
            ? formatCurrency(
                multiPnrResp.reduce((sum, { TotalAmount }) => sum + TotalAmount, 0),
                currency,
                currencyCulture,
                2
              )
            : formatCurrency(price, currency, currencyCulture, 2)
        }
        iconName="flight"
      />
      <Summary>
        {response.AirLegs &&
          response.AirLegs.map((leg) => (
            <InvoiceAirReceiptCard
              key={leg.LegNumber}
              passengerData={passengersData}
              item={leg}
              multiPnrResp={multiPnrResp}
              pnr={pnr}
              flight={response}
            />
          ))}
      </Summary>
      <View style={CommonStyles.pt4}>
        {REBOOK_ENABLED || EVENTS_ENABLED ? (
          passengerName?.map((p, idx) => (
            <>
              <BaseText key={idx}>{p.name}</BaseText>
              <View style={styles.seatView}>
                <BaseText style={styles.seatText}>{p.seat}</BaseText>
              </View>
              <BaseText>
                {t(tKey('TicketNumber'))}: {response?.TicketNumber ? response?.TicketNumber : 'NA'}
              </BaseText>
            </>
          ))
        ) : (
          <>
            <BaseText>
              {response?.AirLegs[0]?.AirSegments[0]?.PassengerSeatMappingList[0]?.PassengerName}
            </BaseText>
            <BaseText>
              {t(tKey('TicketNumber'))}: {response?.TicketNumber ? response?.TicketNumber : 'NA'}
            </BaseText>
          </>
        )}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  seatView: {
    backgroundColor: Color.primary,
    width: '15%',
  },
  seatText: {
    textAlign: 'center',
    color: 'white',
  },
});
export default InvoiceAirSummaryList;
